import { render } from "./TheContato.vue?vue&type=template&id=219af978"
import script from "./TheContato.vue?vue&type=script&lang=js"
export * from "./TheContato.vue?vue&type=script&lang=js"

import "./TheContato.vue?vue&type=style&index=0&id=219af978&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__